<!-- App Header - Fixed top bar -->
<app-header
  [logoUrl]="common.getselectedSectionGroupLogoUrl()"
  [workspaceName]="selectedSection?.sectionName ?? ''"
  [userName]="loginUser.loginUserName ?? ''"
  [userRole]="loginUserJob || '管理者'"
  [showHamburger]="true"
  [showHelp]="false"
  [sidenavCollapsed]="isSidenavCollapsed()"
  (hamburgerClick)="toggleSelf()"
  (logoutClick)="logout()"
  (themeToggle)="toggleTheme()">
  <!-- Workspace selector in header (mat-select style matching home-nav) -->
  <mat-select workspaceSelector
              #sectionSelect
              class="section-select"
              [class.section-select--expanded]="isSectionSelectExpanded"
              [value]="selectedSection"
              [compareWith]="sectionComparison"
              (selectionChange)="switchSection($event)"
              (mousedown)="onSectionSelectMousedown($event)"
              (closed)="onSectionSelectClosed()"
              panelClass="section-select-panel"
              [hideSingleSelectionIndicator]="false">
    <mat-select-trigger>
      <div class="section-select__trigger" (pointerdown)="onTriggerPointerDown($event)">
        <mat-icon class="trigger-icon">domain</mat-icon>
        <span class="trigger-name">{{ selectedSection?.sectionName }}</span>
        <mat-icon class="trigger-arrow">arrow_drop_down</mat-icon>
      </div>
    </mat-select-trigger>
    @for (section of sections; track section.id) {
      <mat-option [value]="section">
        {{ section.sectionName }}
      </mat-option>
    }
  </mat-select>
  <!-- Profile menu items -->
  @if ((systemAdminRole || distributorAgentRole) && contractEnabled) {
    <button profileMenuItems mat-menu-item (click)="openNewWindow('/system-admin/section-groups')">
      <mat-icon>admin_panel_settings</mat-icon>
      <span i18n="@@adminSection.adminNav.label.systemAdmin">システム管理</span>
    </button>
  }
  @if (administeredSectionGroupId) {
    <button profileMenuItems mat-menu-item (click)="openNewWindow('/section-group-admin/' + administeredSectionGroupId + '/home')">
      <mat-icon>domain</mat-icon>
      <span i18n="@@adminSection.adminNav.label.groupAdmin">グループ管理</span>
    </button>
  }
</app-header>

<mat-sidenav-container class="mat-sidenav-container" [class.sidenav-collapsed]="isSidenavCollapsed()" autosize>
  <mat-sidenav #drawer class="mat-sidenav" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="!(isHandset$ | async) && IsNavSystemOpen === true">

      <div class="sidenav">
      <div class="sidenav-main">
        <!-- <ng-template [ngIf]="(recordMeasurerRole || recordRefererRole) && contractEnabled"> -->
        <div class="sidenav-content-panel">
          <!-- Menu -->
          <div class="sidenav-section">
            <h3 class="sidenav-section__title" i18n="@@adminSection.adminNav.title.menu">メニュー</h3>
            <div class="sidenav-menu-items">
            <div class="side_menu_item admin-top">
              <a [routerLink]="['/section-admin', selectedSection.sectionId, 'home']"
                 routerLinkActive="selected">
                <mat-icon aria-hidden="true" fontSet="material-icons-outlined">space_dashboard</mat-icon>
                <span i18n="@@adminSection.adminNav.label.adminHome">ダッシュボード</span>
              </a>
            </div>
            <!-- <div class="side_menu_item staff">
            <ng-template [ngIf]="accountManagementRole">
              <a [routerLink]="['/section-admin/supervisor-list']" (click)="staffList()" [ngClass]="{ 'selected': selectedItem == 1 }">Supervisor一覧</a>
            </ng-template>
          </div> -->
            <div class="side_menu_item staff">
              @if (accountManagementRole) {
                <a [routerLink]="['/section-admin', selectedSection.sectionId, 'staff-list']"
                   routerLinkActive="selected">
                  <mat-icon aria-hidden="true" fontSet="material-icons-outlined">people_alt</mat-icon>
                  <span i18n="@@adminSection.adminNav.label.staffList">スタッフ</span>
                </a>
              }
            </div>
            <div class="side_menu_item contributor">
              @if (accountManagementRole) {
                <a [routerLink]="['/section-admin', selectedSection.sectionId, 'contributor-list']"
                   routerLinkActive="selected">
                  <mat-icon aria-hidden="true" fontSet="material-icons-outlined">supervised_user_circle</mat-icon>
                  <span i18n="@@adminSection.adminNav.label.contributorList">多職種スタッフ</span>
                </a>
              }
            </div>
            <div class="side_menu_item user">
              @if (userManagementRole) {
                <a [routerLink]="['/section-admin', selectedSection.sectionId, 'user-list']"
                   routerLinkActive="selected">
                  <mat-icon aria-hidden="true" fontSet="material-icons-outlined">face</mat-icon>
                  <span i18n="@@adminSection.adminNav.label.userList">ユーザー</span>
                </a>
              }
            </div>
            <div class="side_menu_item user-record">
              @if (userManagementRole) {
                <a [routerLink]="['/section-admin', selectedSection.sectionId, 'records-download-requests']"
                   routerLinkActive="selected">
                  <mat-icon aria-hidden="true" fontSet="material-icons-outlined">cloud_download</mat-icon>
                  <span i18n="@@adminSection.adminNav.label.recordDownload">レコードダウンロード</span>
                </a>
              }
            </div>

            <div class="side_menu_item data-usage">
              @if (yearOfPrevMonth != null) {
                <a [routerLink]="['/section-admin', selectedSection.sectionId, 'monthly-summaries', yearOfPrevMonth, monthOfPrevMonth]"
                   routerLinkActive="selected">
                  <mat-icon aria-hidden="true" fontSet="material-icons-outlined">storage</mat-icon>
                  <span i18n="@@adminSection.adminNav.label.monthlySummary">データ利用量</span>
                </a>
              }
            </div>

            <div class="side_menu_item manual">
              <a [routerLink]="['/section-admin', selectedSection.sectionId, 'manual']"
                 routerLinkActive="selected">
                <mat-icon aria-hidden="true" fontSet="material-icons-outlined">menu_book</mat-icon>
                <span i18n="@@adminSection.adminNav.label.manual">マニュアル</span>
              </a>
            </div>
            <div class="side_menu_item support">
              <a [routerLink]="['/section-admin', selectedSection.sectionId, 'support']"
                 routerLinkActive="selected">
                <mat-icon aria-hidden="true" fontSet="material-icons-outlined">help_outline</mat-icon>
                <span i18n="@@adminSection.adminNav.label.support">サポート</span>
              </a>
            </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer (hidden when collapsed) -->
      @if (!isSidenavCollapsed()) {
        <div class="sidenav-footer">
          <span class="sidenav-footer__text">© {{ year }} PLIMES Inc.</span>
        </div>
      }
    </div>
  </mat-sidenav>

<mat-sidenav-content class="mat-sidenav-content">
  <div class="main-content-area">
    <!-- Contents inside the main screen -->
    @if (error) {
      <div style="background-color: pink; font-size: 0.9em; color: darkred; font-weight: bold;">
        <div style="padding: 5px 5px 5px 5px;"> {{ errorText }} </div>
      </div>
    }
    @if (contractEnabled) {
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    }
  </div>
</mat-sidenav-content>
</mat-sidenav-container>
<!-- ------------------------------------------------------- -->
